import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonComponent } from 'src/app/models/formComponent';
import { NgxPermissionsService } from 'ngx-permissions';
import { ERPCommandeImportDto } from 'src/app/services/api.services';

@Component({
    selector: 'app-erp-import-order-logs-dialog',
    templateUrl: './erp-import-order-logs-dialog.component.html',
    styleUrls: ['./erp-import-order-logs-dialog.component.scss'],
})
export class ErpImportOrderLogsDialogComponent extends CommonComponent implements OnInit {
    loading: boolean = false;
    erpCommandeImports: ERPCommandeImportDto[] = [];
    noCommande: number;
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        public permissionService: NgxPermissionsService,
    ) {
        super();
    }

    ngOnInit() {
        this.noCommande = this.data.noCommande;
        this.erpCommandeImports = this.data.erpCommandeImports;
    }
}
